import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgListAlt(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2.75 4C2.75 3.30964 3.30964 2.75 4 2.75L28 2.75C28.6904 2.75 29.25 3.30964 29.25 4V9C29.25 9.69036 28.6904 10.25 28 10.25L4 10.25C3.30964 10.25 2.75 9.69036 2.75 9L2.75 4ZM5.25 5.25L5.25 7.75L26.75 7.75V5.25L5.25 5.25Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2.75 23.0012C2.75 22.3109 3.30964 21.7512 4 21.7512L28 21.7512C28.6904 21.7512 29.25 22.3109 29.25 23.0012V28.0012C29.25 28.6916 28.6904 29.2512 28 29.2512L4 29.2512C3.30964 29.2512 2.75 28.6916 2.75 28.0012L2.75 23.0012ZM5.25 24.2512V26.7512L26.75 26.7512V24.2512L5.25 24.2512Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2.75 13.5C2.75 12.8096 3.30964 12.25 4 12.25L28 12.25C28.6904 12.25 29.25 12.8096 29.25 13.5L29.25 18.5C29.25 19.1904 28.6904 19.75 28 19.75L4 19.75C3.30964 19.75 2.75 19.1904 2.75 18.5L2.75 13.5ZM5.25 14.75V17.25L26.75 17.25V14.75L5.25 14.75Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgListAlt);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
